export const WAYPOINT_ICON_IMAGE_ID = 'rt-waypoint-icon';

const _ICON_SIZE_PX = 24;

// Waypoint marker: amber diamond with a centred white dot. Distinct from
// every other circular symbol on the map (detour dots, selected halos,
// industrial points), keeps the "route passes through this point"
// semantics that QGIS/ArcGIS use for diamond-shaped waypoints.
const _WAYPOINT_SVG = `
<svg xmlns="http://www.w3.org/2000/svg" width="${_ICON_SIZE_PX}" height="${_ICON_SIZE_PX}" viewBox="0 0 24 24">
  <path d="M12 1.2 L22.8 12 L12 22.8 L1.2 12 Z" fill="#fa8c16" stroke="#ffffff" stroke-width="2.2" stroke-linejoin="round"/>
  <path d="M12 1.2 L22.8 12 L12 22.8 L1.2 12 Z" fill="none" stroke="#873800" stroke-width="0.6" stroke-linejoin="round" stroke-opacity="0.6"/>
  <circle cx="12" cy="12" r="2.6" fill="#ffffff"/>
</svg>
`.trim();

export function buildWaypointIconDataUrl(): string {
  const encoded = encodeURIComponent(_WAYPOINT_SVG);
  return `data:image/svg+xml;charset=utf-8,${encoded}`;
}

export function loadWaypointIconImage(): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image(_ICON_SIZE_PX, _ICON_SIZE_PX);
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error('failed to load waypoint icon'));
    img.src = buildWaypointIconDataUrl();
  });
}
